/**
 * Where the half-finished deposit lives, and who is allowed to forget it.
 *
 * The deposit screen opens the payment before it shows the bank account, so from that moment the
 * customer is holding a `WIC-PAY-…` reference for a payment that already exists and may already
 * have money on its way to it. That is worth surviving an accidental reload — hence the draft.
 *
 * It is also worth NOT surviving a sign-out, which is why the key and the clearing live here
 * rather than inside the page. `clearSessionData` has to be able to remove it without importing
 * the deposit screen, and the alternative — repeating the literal string in both files — is
 * exactly the drift that let the draft outlive its owner in the first place.
 *
 * `sessionStorage`, not `localStorage`: this belongs to the tab the customer is transferring in,
 * and it should not resurface in a new window days later. Note that a tab survives sign-out, so
 * per-tab is not the same as per-person.
 */

export const DEPOSIT_DRAFT_KEY = "wicloud_deposit_draft";

/** Forget the draft. Safe to call when there is none, and when storage is unavailable. */
export function clearDepositDraft(): void {
  try {
    sessionStorage.removeItem(DEPOSIT_DRAFT_KEY);
  } catch {
    // Private-mode storage, or storage disabled. There is no state to correct if the removal
    // itself failed.
  }
}
